import { goldsboroConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function GoldsboroPage() {
  return <CityPageTemplate config={goldsboroConfig} />;
}